import api from "./axiosConfig";

// Obtener todos los productos.
//
// (2026-08-02, ítem 31 + bug P2 "listas truncadas") Reescrito sobre `params` de
// axios. Dos correcciones y una capacidad nueva:
//   - BUG CORREGIDO (paginación truncada): ninguna de las dos ramas pedía el
//     lote completo, así que la lista de productos mostraba SOLO la primera
//     página del backend (20 filas) mientras DataTables decía paginar sobre el
//     total. Ahora:
//       · /api/products/  → request_type='all' (product_routes.py:339-353
//         devuelve el conjunto completo con la misma envoltura {data,...}).
//       · /admin/products → NO soporta 'all'; pagina siempre
//         (admin_routes.py:694-700), así que se pide request_type='export'
//         (eleva el tope a MAX_PER_PAGE_EXPORT=5000) + per_page=5000.
//   - `empresa_id` es el nombre CORRECTO del filtro por empresa/tercero dueño de
//     los productos y tiene PRIORIDAD en el backend (product_routes.py:235);
//     `client_id` se mantiene por compatibilidad con los llamadores existentes.
//     /admin/products solo entiende `empresa_id`.
//   - `search`: búsqueda de texto libre ya soportada por el backend
//     (product_routes.py:288-305).
// Devuelve SIEMPRE el array de productos (misma forma que antes).
export const getProducts = async ({
  client_id = false,
  empresa_id = false,
  search = false,
  request_type = null,
  page = null,
  per_page = null,
} = {}) => {
  const authData = localStorage.getItem("authData");
  if (!authData) return [];
  const { rol } = JSON.parse(authData);
  const esGlobal = rol == 'admin' || rol == 'auditor';

  // Prioridad: empresa_id (nombre correcto) > client_id (deprecado).
  const owner = (empresa_id !== false && empresa_id != null && empresa_id !== '')
    ? empresa_id
    : ((client_id !== false && client_id != null && client_id !== '') ? client_id : null);

  const params = {};
  if (owner != null) params.empresa_id = owner;
  if (search !== false && search != null && String(search).trim() !== '') {
    params.search = String(search).trim();
  }
  if (page != null) params.page = page;
  if (per_page != null) params.per_page = per_page;
  if (request_type != null) params.request_type = request_type;

  var response;
  if (esGlobal && owner == null) {
    // Rol global sin dueño concreto: catálogo completo de TODAS las empresas.
    if (params.request_type == null) {
      params.request_type = 'export';
      if (params.per_page == null) params.per_page = 5000;
    }
    response = await api.get(`/admin/products`, { params });
  } else {
    // Ruta de empresa. Con `empresa_id` el backend valida que el tercero
    // pertenezca al emisor del token; para admin/auditor resuelve global.
    if (params.request_type == null) params.request_type = 'all';
    response = await api.get('/api/products/', { params });
  }
  const body = response?.data;
  if (Array.isArray(body)) return body;
  return (body && Array.isArray(body.data)) ? body.data : [];
};

// Get a product by ID
export const showProduct = async (id) => {
  const response = await api.get(`/api/products/${id}`);
  return response.data;
};

// Create a product
export const createProduct = async (body) => {
  const response = await api.post("/api/products/", body);
  return response.data.data;
};

// Update a product
export const editProduct = async (id, body) => {
  const response = await api.put(`/api/products/${id}`, body);
  return response.data.data;
};

// Delete a product
export const deleteProduct = async (id) => {
  const response = await api.delete(`/api/products/${id}`);
  return response.data;
};

export const activateProduct = async (id) => {
  try {
    const response = await api.put(`/api/products/${id}/activar`);
    //console.log('activateProduct-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al activar el producto:", error);
    throw error;
  }
};